import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { dutyStatusChangeRefs } from "../subjects/dutyStatusChange/refs";

/**
 * The driver went on the clock as driving.
 */
export const drivingV1 = tmsEventKind(
  { category: "dutyStatus", kind: "driving", version: 1 },
  {
    refs: dutyStatusChangeRefs,
    facts: {
      /** Whether a second driver was signed in — a flag, never the co-driver's identity. */
      withCoDriver: z.boolean(),
    },
  },
);

export const DrivingV1Schema = drivingV1.schema;
export const DrivingV1FactsSchema = drivingV1.facts;

export type DrivingV1 = z.infer<typeof DrivingV1Schema>;
export type DrivingV1Facts = z.infer<typeof DrivingV1FactsSchema>;

/** Every version of `driving`, keyed by version. What `catalog.ts` places under `dutyStatus`. */
export const driving = { 1: drivingV1 } as const;
